import { EventRepository } from '~repositories/EventRepository';
import * as views from '../../constants/Views';
import serviceNames from '~setup/AnalyticsService';
import { diContainer } from '~setup/diContainer';
import { Event } from '~entities/Event';

export class AccountPageLandedUseCase {
    private eventRepository: EventRepository;

    constructor() {
        this.eventRepository = diContainer.get(serviceNames.eventRepository);
    }

    public execute = () => {
        const newEvent = new Event({
            id: this.eventRepository.generateId(),
            name: views.ACCOUNT_VIEW,
            type: 'data'
        });

        this.eventRepository.addEventToQueue(newEvent);
    };
}
